function ulid () {
  // Timestamp (48 bit) - milisekundy od epoch
  const timestamp = Math.floor(Date.now()).toString(36).padStart(10, '0')

  // Random (80 bit) - 10 bajtów entropii
  let random = ''
  for (let i = 0; i < 10; i++) {
    random += Math.floor(Math.random() * 0x100000000).toString(32)[0]
  }

  return timestamp + random.padEnd(16, '0').slice(0, 16)
}

export { ulid }
